import React from 'react';
import './styles/tjenester.css';
import SEO from '../../components/SEO';
import Header from '../../components/header';
import Footer from '../../components/footer';
import ArtikelSektion from '../../components/artikelsektion';
import Testimonials from '../../components/testimonials';
import TjenesterFAQ from '../../components/TjenesterFAQ';
import CTAKnap, { CTAIkoner } from '../../components/ctaknap';
import nicolaiImage from '../../images/os/nicolai-pb.webp';

const TjenesterHero = () => {
  return (
    <section className="tjenester-hero">
      <div className="container">
        <div className="tjenester-hero-content">
          <div className="tjenester-hero-text">
            <div className="tjenester-hero-badge">
              <span>Webdesign til virksomheder</span>
            </div>
            <h1 className="tjenester-hero-title">
              En <span className="tjenester-hero-accent">hjemmeside</span>, der 
              arbejder døgnet rundt
            </h1>
            <p className="tjenester-hero-description">
              Betragt din hjemmeside som din mest effektive medarbejder: altid tilgængelig, altid professionel og altid klar til at tage imod dine kunder. Vi bygger moderne og mobilvenlige hjemmesider, der ikke bare præsenterer din virksomhed flot, men som også gør det let for dine besøgende at tage det næste skridt – uanset om det er et opkald, en forespørgsel eller et køb.
            </p>
            <div className="tjenester-hero-stats">
              <div className="tjenester-hero-stat">
                <div className="tjenester-hero-stat-number">100+</div>
                <div className="tjenester-hero-stat-label">Hjemmesider skabt</div>
              </div>
              <div className="tjenester-hero-stat">
                <div className="tjenester-hero-stat-number">4.8★</div>
                <div className="tjenester-hero-stat-label">Google rating</div>
              </div>
              <div className="tjenester-hero-stat">
                <div className="tjenester-hero-stat-number">2021</div>
                <div className="tjenester-hero-stat-label">Etableret</div>
              </div>
            </div>
            <div className="tjenester-hero-actions">
              <CTAKnap 
                variant="primary" 
                size="large"
                href="/hjemmesider"
                icon={<CTAIkoner.ArrowRight />}
              >
                Hjemmesider
              </CTAKnap>
              <CTAKnap 
                variant="outline" 
                size="large"
                href="/priser#prisudregner"
                icon={<CTAIkoner.Search />}
              >
                Få en pris
              </CTAKnap>
            </div>
          </div>
          <div className="tjenester-hero-visual">
            <div className="tjenester-hero-image">
              <img 
                src={nicolaiImage} 
                alt="Nicolai fra Parla Branding" 
                className="tjenester-hero-photo"
              />
              <div className="person-badge">
                <div className="person-name">Nicolai</div>
                <div className="person-title">Vores CTO</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const HjemmesideSektion = () => {
  return (
    <section className="tjenester-hjemmesider" id="hjemmesider">
      <div className="container">
        <div className="tjenester-section-layout">
          <div className="tjenester-section-image">
            <div className="hjemmeside-visual">
              <div className="website-mockup">
                <div className="mockup-container">
                  <div className="mockup-screen">
                    <div className="screen-header">
                      <div className="screen-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    <div className="screen-content">
                      <div className="content-bar large"></div>
                      <div className="content-bar medium"></div>
                      <div className="content-bar small"></div>
                      <div className="content-grid">
                        <div className="grid-item"></div>
                        <div className="grid-item"></div>
                        <div className="grid-item"></div>
                        <div className="grid-item"></div>
                      </div>
                      <div className="content-bar large"></div>
                      <div className="content-bar medium"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="tjenester-section-content">
            <div className="tjenester-section-header">
              <div className="tjenester-section-badge">
                <span>Professionelle hjemmesider</span>
              </div>
              <h2 className="tjenester-section-title">
                Et stærkt digitalt <span className="tjenester-accent">fundament</span> for din virksomhed
              </h2>
              <p className="tjenester-section-description">
                En hjemmeside bør være jeres vigtigste digitale aktiv. Fokus ligger derfor i at bygge en platform, der afspejler jeres professionalisme og skaber en meningsfuld oplevelse for de besøgende. Resultatet er en langsigtet løsning, der styrker troværdigheden, bygger tillid og understøtter jeres overordnede forretningsmål.
              </p>
            </div>

            <div className="tjenester-features-list">
              <div className="tjenester-feature-item">
                <div className="feature-icon">
                  <CTAIkoner.Check />
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">Et gennemtænkt og brugervenligt design</h3>
                  <p className="feature-description">
                    Kernen i en succesfuld hjemmeside er en god brugeroplevelse. Et logisk og intuitivt design sikrer, at jeres budskab altid står klart – uanset om kunden bruger mobil, tablet eller computer.
                  </p>
                </div>
              </div>
              
              <div className="tjenester-feature-item">
                <div className="feature-icon">
                  <CTAIkoner.ArrowRight />
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">En platform bygget til at præstere</h3>
                  <p className="feature-description">
                    Teknisk performance er afgørende for både brugere og søgemaskiner. En let og hurtig løsning med ren kode skaber et bedre flow for de besøgende og et sundere teknisk fundament for siden.
                  </p>
                </div>
              </div>
              
              <div className="tjenester-feature-item">
                <div className="feature-icon">
                  <CTAIkoner.Check />
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">Et fundament for synlighed</h3>
                  <p className="feature-description">
                    For at kunne blive fundet, skal en hjemmeside bygges på et teknisk grundlag, som søgemaskiner forstår. Det giver det bedst mulige udgangspunkt for at styrke den organiske synlighed over tid.
                  </p>
                </div>
              </div>
              
              <div className="tjenester-feature-item">
                <div className="feature-icon">
                  <CTAIkoner.ArrowRight />
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">Integreret sikkerhed og stabilitet</h3>
                  <p className="feature-description">
                    Tryghed og stabilitet er ikke en eftertanke. Anerkendte sikkerhedsstandarder som SSL-certifikat er en integreret del af løsningen og sikrer en robust platform for både jer og jeres kunder.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="tjenester-section-cta">
              <a href="/hjemmesider" className="tjenester-cta-button">
                Se hjemmeside tjenester
                <CTAIkoner.ArrowRight />
              </a>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
};

const SEOSektion = () => {
  return (
    <section className="tjenester-seo" id="seo">
      <div className="container">
        <div className="tjenester-section-layout">
          <div className="tjenester-section-content">
            <div className="tjenester-section-header">
              <div className="tjenester-section-badge">
                <span>SEO Optimering som Tillæg</span>
              </div>
              <h2 className="tjenester-section-title">
                Fra en god hjemmeside til en <span className="tjenester-accent">synlig forretning</span>
              </h2>
              <p className="tjenester-section-description">
                En professionel hjemmeside er fundamentet. Næste skridt er at sikre, at potentielle kunder rent faktisk finder den.
                <br /><br />
                Målrettet SEO-arbejde handler om at gøre din virksomhed synlig på Google, præcis i det øjeblik en kunde har brug for det, du tilbyder. Det er ikke et quick-fix, men en langsigtet og værdifuld investering i din online tilstedeværelse.
              </p>
            </div>

            <div className="seo-stats-compact">
              <div className="stat-item">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Support tilgængelig</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">5.000</div>
                <div className="stat-label">kr/måned fra</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">transparente priser</div>
              </div>
            </div>

            <div className="seo-benefits-list">
              <div className="benefit-item">
                <div className="benefit-icon">
                  <CTAIkoner.Check />
                </div>
                <div className="benefit-content">
                  <h3>Flere relevante besøgende</h3>
                  <p>En bedre placering på Google fører naturligt til flere besøgende på din hjemmeside – helt uden at du skal betale for hvert enkelt klik.</p>
                </div>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">
                  <CTAIkoner.ArrowRight />
                </div>
                <div className="benefit-content">
                  <h3>Kunder, der allerede leder efter dig</h3>
                  <p>Skønheden ved SEO er, at du bliver fundet af kunder, der aktivt er på udkig efter netop dine ydelser. Det giver varmere henvendelser og et bedre udgangspunkt for dialog.</p>
                </div>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">
                  <CTAIkoner.Check />
                </div>
                <div className="benefit-content">
                  <h3>En mere værdifuld markedsføring</h3>
                  <p>En stærk synlighed på Google er et aktiv, der arbejder for dig døgnet rundt. Over tid giver det ofte et markant bedre afkast end betalte annoncekroner.</p>
                </div>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">
                  <CTAIkoner.ArrowRight />
                </div>
                <div className="benefit-content">
                  <h3>En investering i din virksomheds fremtid</h3>
                  <p>Godt SEO-arbejde har en sneboldeffekt. Resultaterne forsvinder ikke, når en kampagne stopper, men bygger sig tværtimod stærkere over tid og bliver et varigt aktiv.</p>
                </div>
              </div>
            </div>
            
            <div className="tjenester-section-cta">
              <a href="/seo" className="tjenester-cta-button">
                Læs om SEO tjenester
                <CTAIkoner.ArrowRight />
              </a>
            </div>
          </div>
          
          <div className="tjenester-section-image">
            <div className="seo-visual">
              <div className="google-serp">
                <div className="serp-header">
                  <div className="google-logo">Google</div>
                  <div className="search-box">
                    <div className="search-query">din branche</div>
                  </div>
                </div>
                <div className="serp-info">
                  <span>Cirka 1.250.000 resultater (0,32 sekunder)</span>
                </div>
                <div className="serp-results">
                  <div className="serp-result serp-result--highlighted">
                    <div className="result-url">dinvirksomhed.dk</div>
                    <div className="result-title">Din Virksomhed - Din Branche</div>
                    <div className="result-description">
                      Beskrivelse af din virksomhed og dine services. Kontakt os for mere information eller book en tid direkte online.
                    </div>
                    <div className="result-position">#3</div>
                  </div>
                  <div className="serp-result">
                    <div className="result-url">konkurrent1.dk</div>
                    <div className="result-title">Anden virksomhed i din branche</div>
                    <div className="result-description">
                      Lignende tjenester som dine, men du rangerer også godt...
                    </div>
                  </div>
                  <div className="serp-result">
                    <div className="result-url">konkurrent2.dk</div>
                    <div className="result-title">Endnu en konkurrent</div>
                    <div className="result-description">
                      Der er flere gode virksomheder i din branche på Google...
                    </div>
                  </div>
                </div>
                <div className="serp-achievement">
                  <div className="achievement-badge">
                    <span className="achievement-icon">✓</span>
                    <span className="achievement-text">Bedre synlighed på Google</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
};

const TjenesterPage = () => {
  return (
    <>
      <SEO 
        title="Vores Tjenester - Professionelle Hjemmesider & SEO | Parla Branding"
        description="Se en oversigt over, hvordan vi hjælper virksomheder med digital succes. Vores kernekompetence er skræddersyede hjemmesider med mulighed for avanceret SEO."
        keywords="hjemmeside tjenester, webdesign services, professionelle hjemmesider, SEO optimering, digital succes, skræddersyede hjemmesider"
        ogImage="/og-image.jpg"
        canonicalUrl="https://www.parlabranding.dk/tjenester"
        isService={true}
        serviceData={{
          name: "Professionel Hjemmeside Design",
          description: "Vi designer og udvikler professionelle hjemmesider for danske virksomheder",
          price: "10000"
        }}
      />
      
      <Header />
      <TjenesterHero />
      <Testimonials />
      <HjemmesideSektion />
      <SEOSektion />
      <ArtikelSektion />
      <TjenesterFAQ />
      <Footer />
    </>
  );
};

export default TjenesterPage;
